import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'store/selectors/user';
import { useDeleteSurveyMutation, useGetAllSurveysQuery } from 'store/services/feedbackGroup';
import Table from 'style-guide/Table';
import { getSurveyManageColumns } from './SurveyManageColumns';

const SurveyManage = () => {
  const user = useSelector(getUserData);

  const { data } = useGetAllSurveysQuery({ userId: user.id });
  const [deleteSurvey] = useDeleteSurveyMutation();
  const navigate = useNavigate();

  const handlePencilClick = (surveyId) => {
    navigate(`/survey/create/introduction/${surveyId}`);
  };

  const onDelete = (surveyId) => {
    deleteSurvey({ id: surveyId });
  };

  const formattedData =
    data?.map((survey) => ({
      id: survey.id,
      title: survey.title,
      linkedLC: survey.courses || 'N/A',
      createdBy: survey.user || 'Unknown',
      status: survey.statusId,
      responses: survey.responseCount || '-',
      lastUpdated: survey.updatedAt
        ? new Date(survey.updatedAt).toLocaleDateString()
        : new Date(survey.createdAt).toLocaleDateString(),
    })) || [];

  return (
    <Table
      columns={getSurveyManageColumns({ handlePencilClick, onDelete })}
      rowKey={(e) => e.key}
      data={formattedData}
    />
  );
};

export default SurveyManage;
